// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-mitarbeiter-gewinnen-hsc-2000-coburg-tickets/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzMitarbeiterGewinnenHsc2000CoburgTicketsDE: PageEntry = {
  id: "post.dietz-mitarbeiter-gewinnen-hsc-2000-coburg-tickets",
  locale: "de",
  slug: "dietz-mitarbeiter-gewinnen-hsc-2000-coburg-tickets",
  seo: {
    title: "Dietz Mitarbeiter gewinnen HSC 2000 Coburg Tickets | Dietz GmbH",
    description: "Dietz Mitarbeiter gewinnen HSC 2000 Coburg Tickets",
  },
  type: "post",
  h1: "Dietz Mitarbeiter gewinnen HSC 2000 Coburg Tickets",
  blocks: [
    { kind: "heading", level: 2, text: "Dietz Mitarbeiter gewinnen HSC 2000 Coburg Tickets" },
    { kind: "paragraph", text: "Wir freuen uns riesig über die zahlreichen Likes unserer Beiträge via Facebook und Instagram! Besonderer Dank gilt unseren Mitarbeitern, die uns so großartig und zahlreich unterstützen! Drei unserer Mitarbeiter durften sich deshalb besonderes freuen, denn Sie haben bei einer internen Auslosung je zwei Tickets für ein Heimspiel des HSC 2000 Coburg gewonnen." }
  ],
};
